<template>
  <div>
    <load-profile />
    <b-card id="container" ref="container">
      <b-card-text class="mb-2">
        <h5>
          {{ $t("pages.chatAssignment.desc") }}
        </h5>
      </b-card-text>
      <div class="d-flex flex-row mb-4">
        <div
          class="d-flex flex-row flex-item--half border rounded px-2 py-2 mr-4 justify-content-between"
          :class="isManual ? 'border-primary' : ''"
          @click="isManual = true"
        >
          <div class="d-flex flex-column">
            <h4>{{ $t("pages.chatAssignment.options.manual.title") }}</h4>
            <span>{{ $t("pages.chatAssignment.options.manual.desc") }}</span>
          </div>
          <b-form-checkbox v-model="isManual" @change="isManual = true" />
        </div>
        <div
          class="d-flex flex-row border flex-item--half rounded px-2 py-2 justify-content-between"
          :class="isAuto ? 'border-primary' : ''"
          @click="isAuto = true"
        >
          <div class="d-flex flex-column">
            <h4>{{ $t("pages.chatAssignment.options.auto.title") }}</h4>
            <span>{{ $t("pages.chatAssignment.options.auto.desc") }} </span>
          </div>
          <b-form-checkbox v-model="isAuto" @change="isAuto = true" />
        </div>
      </div>
      <div class="d-flex flex-row mb-4 mr-4">
        <div
          class="d-flex flex-row flex-item--half border rounded px-2 py-2 justify-content-between"
          :class="isAutoRanking ? 'border-primary' : ''"
          @click="isAutoRanking = true"
        >
          <div class="d-flex flex-column">
            <h4>{{ $t("pages.chatAssignment.options.autoRanking.title") }}</h4>
            <span>{{
              $t("pages.chatAssignment.options.autoRanking.desc")
            }}</span>
          </div>
          <b-form-checkbox
            v-model="isAutoRanking"
            @change="isAutoRanking = true"
          />
        </div>
      </div>
      <div class="d-flex flex-row justify-content-end">
        <b-button variant="primary" @click="updateAssignment">
          {{ $t("button.saveChanges") }}
        </b-button>
      </div>
    </b-card>

    <!-- // chat bot setting? -->

    <div>
      <load-profile />
      <b-card id="container" ref="container">
        <b-card-text class="mb-2">
          <h5>
            {{ $t("pages.chatAssignment.botDesc") }}
          </h5>
        </b-card-text>
        <div class="d-flex flex-row mb-4 mr-4">
          <div
            class="d-flex flex-row flex-item--half border rounded px-2 py-2 justify-content-between"
            :class="bot ? 'border-primary' : ''"
            @click="bot = !bot"
          >
            <div class="d-flex flex-column">
              <h4>
                {{ $t("pages.chatAssignment.options.bot.title") }}
              </h4>
              <span>{{ $t("pages.chatAssignment.options.bot.desc") }}</span>
            </div>
            <b-form-checkbox v-model="bot" @change="bot = !bot" />
          </div>
        </div>
        <div class="d-flex flex-row justify-content-end">
          <b-button variant="primary" @click="updateAssignment">
            {{ $t("button.saveChanges") }}
          </b-button>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
import { BCard, BCardText, BFormCheckbox, BButton } from "bootstrap-vue";
import Repository from "@/repositories/RepositoryFactory";
import ChatAssignmentRespository from "@/repositories/Api/ChatAssignmentRespository";

const ChatAssignmentRepository = Repository.get("chatAssignmentRepository");

export default {
  components: {
    BCard,
    BCardText,
    BFormCheckbox,
    BButton,
  },
  data: () => ({
    isManual: false,
    isAuto: true,
    isAutoRanking: false,
    bot: false,
    manualDesc: "",
    autoDesc: "",
  }),
  watch: {
    isManual(newValue, oldValue) {
      if (newValue) {
        this.isAuto = oldValue;
        this.isAutoRanking = oldValue;
        // this.bot = oldValue;
      }
    },
    isAuto(newValue, oldValue) {
      if (newValue) {
        this.isAutoRanking = oldValue;
        this.isManual = oldValue;
        // this.bot = oldValue;
      }
    },
    isAutoRanking(newValue, oldValue) {
      if (newValue) {
        this.isManual = oldValue;
        this.isAuto = oldValue;
        // this.bot = oldValue;
      }
    },
    // bot(newValue, oldValue) {
    //   if (newValue) {
    //     this.isManual = oldValue;
    //     this.isAuto = oldValue;
    //     this.isAutoRanking = oldValue;
    //   }
    // },
  },
  async mounted() {
    await this.getAssignment();
  },
  methods: {
    async getAssignment() {
      try {
        const response = await ChatAssignmentRepository.show();
        const { data } = response.data;
        console.log(data, "get data");
        const {
          auto,
          manual,
          autoDescription,
          manualDescription,
          autoRanking,
          bot,
        } = data;
        this.isAuto = auto;
        this.isManual = manual;
        this.autoDesc = autoDescription;
        this.manualDesc = manualDescription;
        this.isAutoRanking = autoRanking;
        this.bot = bot;
      } catch (err) {
        const { data } = err.response;
        const { message } = data;
        if (message === "error.recordNotFound") await this.createAssignment();
      }
    },
    async createAssignment() {
      try {
        const payload = {
          manual: this.isManual,
          manualDescription:
            "Operators assign themselves to selected conversations.",
          auto: this.isAuto,
          autoDescription:
            "Operators are assigned automatically to conversations evenly in sequential order.",
        };
        const response = await ChatAssignmentRepository.create(payload);
        await this.getAssignment();
      } catch (err) {
        alert(err);
      }
    },
    async updateAssignment() {
      try {
        const payload = {
          manual: this.isManual,
          manualDescription: this.manualDesc,
          auto: this.isAuto,
          autoDescription: this.autoDesc,
          autoRanking: this.isAutoRanking,
          bot: this.bot,
        };
        const response = await ChatAssignmentRespository.update(payload);
      } catch (err) {
        alert(err);
      } finally {
        await this.getAssignment();
      }
    },
  },
  setup() {
    const permissionType = "chat-settings";
    return { permissionType };
  },
};
</script>

<style class="scss" scoped>
.flex-item--half {
  cursor: pointer;
  width: 100%;
  max-width: 50%;
}
</style>
